import { useState } from "react";
import { JSONTree } from "react-json-tree";
import type { RoomConfig } from "@tuit/shared-types";
import styles from "../../styles/components/AdminPage.module.css";

interface Props {
  config: RoomConfig | null;
  roomId: string;
  onSelectSource: (id: string) => void;
}

function RoomConfigContent({ config, onSelectSource }: { config: RoomConfig; onSelectSource: (id: string) => void }) {
  return (
    <table className={styles.table}>
      <tbody>
        <tr>
          <td className={styles.configKey}>ID</td>
          <td>{config.id}</td>
        </tr>
        <tr>
          <td className={styles.configKey}>Title</td>
          <td>{config.title}</td>
        </tr>
        <tr>
          <td className={styles.configKey}>Refresh</td>
          <td>{config.refreshIntervalMinutes} min</td>
        </tr>
        <tr>
          <td className={styles.configKey}>Sources</td>
          <td>
            <div className={styles.sourceIdList}>
              {config.sourceIds.map((id) => (
                <button key={id} type="button" className={styles.clickableId} onClick={() => onSelectSource(id)}>
                  {id}
                </button>
              ))}
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  );
}

export function RoomConfigTable({ config, roomId, onSelectSource }: Props) {
  const [view, setView] = useState<"ux" | "json">("ux");

  return (
    <div className={styles.panel}>
      <div className={styles.panelHeader}>
        <h2 className={styles.panelTitle}>Room Config: {roomId}</h2>
        {config && (
          <div className={styles.viewToggle}>
            {(["ux", "json"] as const).map((v) => (
              <button
                key={v}
                type="button"
                className={`${styles.viewToggleBtn} ${view === v ? styles.viewToggleBtnActive : ""}`}
                onClick={() => setView(v)}
              >
                {v.toUpperCase()}
              </button>
            ))}
          </div>
        )}
      </div>
      <div className={styles.panelBody}>
        {!config
          ? <span className={styles.panelEmpty}>Load a Room Config to see details.</span>
          : view === "json"
            ? <JSONTree data={config} />
            : <RoomConfigContent config={config} onSelectSource={onSelectSource} />
        }
      </div>
    </div>
  );
}
